export const KEY_ROTATION_REQUIRED = 1400087;
export const KEY_ALREADY_ROTATED = 1409004;
export const ENCRYPTION_KEY_URL_MISMATCH = 1400049;
